import BaseCompactCard from './BaseCompactCard'

import LineMapPinIcon from 'LuxKit/Icons/line/LineMapPinIcon'
import type {
  AttractionItem,
  EventItem,
  ExperienceItem,
  RestaurantBarItem,
  ThingToDoItem,
} from 'tripPlanner/types/tripItem'
import { getDisplayableCustomThingToDoName } from 'tripPlanner/utils/itemConversions/common'
import type { DetailItemCardVariant } from '../DetailItemCard/common/types'

interface Props {
  item:
    | AttractionItem
    | EventItem
    | ExperienceItem
    | RestaurantBarItem
    | ThingToDoItem
  variant: DetailItemCardVariant
}

function CompactThingToDoCard({ item, variant }: Props) {
  const title =
    item.type === 'EXPERIENCE' ?
      item.name :
        getDisplayableCustomThingToDoName(item)

  return (
    <BaseCompactCard
      item={item}
      icon={<LineMapPinIcon size="S" />}
      title={title}
      isPrimary
      variant={variant}
    />
  )
}

export default CompactThingToDoCard
